/**
 * Web stub — biometric credential storage is native-only. Keeps `react-native-keychain`
 * (no web build) out of the web bundle while exposing the same surface so callers don't
 * need platform branches. Everything reports "nothing stored".
 */
export type BiometricProvider = 'email' | 'google' | 'apple';

export type BiometricCredential = {
  email: string;
  password: string;
  provider: BiometricProvider;
};

export const saveBiometricCredential = async (
  _uid: string,
  _credential: BiometricCredential,
): Promise<boolean> => false;

export const getBiometricCredential = async (_uid: string): Promise<null> => null;

export const clearBiometricCredential = async (_uid: string): Promise<void> => undefined;
